<div class="d-flex align-content-center h-100 toggle-items" *ngIf="!hide">
  <mat-slide-toggle [(ngModel)]="checked" (change)="onChange($event)"> </mat-slide-toggle>
  <span *ngIf="checked" class="toggle-on" translate>{{ labelOn }}</span>
  <span *ngIf="!checked" class="toggle-off" translate>{{ labelOff }}</span>
</div>
